<script lang="ts">
import Vue from 'vue';
import InfoBubble from './Common/InfoBubble.vue';

export default Vue.extend({
  name: 'MLabelRow',
  components: {
    InfoBubble,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
</script>

<template>
  <div class="m-label-row">
    <InfoBubble v-if="$slots.infotext">
      <template #default>{{ label }}</template>
      <template #infotext><slot name="infotext" /></template>
    </InfoBubble>
    <span v-else>{{ label }}</span>
  </div>
</template>

<style scoped lang="scss">
.m-label-row {
  font-size: 12px;
  color: var(--v-strong-base);

  &.high-contrast {
    color: var(--v-strong-base);
  }

  &.muted {
    color: var(--v-default-base);
  }

  &.muted.focused {
    color: var(--v-strong-base);
  }
}
</style>
